import {match} from 'ts-pattern';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {DiscountWorkRate, GetDirectSaleDiscountResponse} from '@dms/api/warehouse';

const PERCENTAGE_BASE = 100;

type WorkDiscountDefaults = {
  discountType: 'percentage' | 'workRate';
  discountValue: DiscountWorkRate[] | number;
};

/**
 * Derives the work-discount form defaults from the direct-sale discount GET response.
 *
 * The backend returns `discountedWorkRate` as an empty array (not omitted) when the saved
 * discount is a plain percentage. Both the discount type and the discount value must treat an
 * empty array as "no work-rate discount" — otherwise the percentage value is dropped (an empty
 * array is not nullish, so a `??` fallback never runs) and the percentage field renders empty
 * after a page reload (T20-130951).
 */
export function getWorkDiscountDefaults(
  workDiscount: GetDirectSaleDiscountResponse['workDiscount'] | undefined
): WorkDiscountDefaults {
  return match(workDiscount?.discountedWorkRate)
    .when(
      isNotNilOrEmpty,
      (discountedWorkRate): WorkDiscountDefaults => ({
        discountType: 'workRate',
        discountValue: discountedWorkRate,
      })
    )
    .otherwise(
      (): WorkDiscountDefaults => ({
        discountType: 'percentage',
        discountValue: (workDiscount?.percentageDiscount ?? 0) * PERCENTAGE_BASE,
      })
    );
}
